import React from 'react';
import { Spin } from 'antd';

const LazyExpirationPage = React.lazy(() => import('./Expiration'));
export const AsyncExpirationPage: React.FC = () => (
	<React.Suspense fallback={<Spin />}>
		<LazyExpirationPage />
	</React.Suspense>
);
